import React, {Component} from 'react';
import firebase from '../data/firebase.js';

class Bio extends Component {
  constructor() {
    super();
    this.state = {
      items: []
    }
  }

  componentDidMount() {
    document.body.classList.add(this.props.pageBackground);
    const itemsRef = firebase.database().ref().child('bio');
    itemsRef.on('value', (snapshot) => {
      let items = snapshot.val();
      let newState = [];
      for (let item in items) {
        newState.push({
          id: item.id,
          title: items[item].title,
          intro: items[item].intro,
          content: items[item].content
        });
      }

      this.setState({
        items: newState
      });
    });
  }

  render() {
    return (
      <section className='container'>
        {this.state.items.map((item, i) => {
          return (
            <div key={i}>
              <h1>{item.title}</h1>
              <h2>{item.intro}</h2>
              <hr/>
              <div className="primary-content">
                <div dangerouslySetInnerHTML={{__html: item.content}}></div>
              </div>
            </div>
          )
        })}
      </section>
    );
  }
}

export default Bio;
